export const PARAGRAPH_METADATA_DESKTOP_FONT_SIZE_COEFF = 1
export const PARAGRAPH_METADATA_MOBILE_FONT_SIZE_COEFF = 0.875
export const PARAGRAPH_METADATA_LINE_HEIGHT_COEFF = 1.5
export const PARAGRAPH_METADATA_DESKTOP_MARGIN = 4
export const PARAGRAPH_METADATA_MOBILE_MARGIN = 8

export const PARAGRAPH_SPEAKER_NAME_DESKTOP_PADDING = 4
export const PARAGRAPH_SPEAKER_NAME_MOBILE_PADDING = 5

export const PARAGRAPH_CONTAINER_DESKTOP_PADDING = 8
export const PARAGRAPH_CONTAINER_MOBILE_PADDING = 8
export const PARAGRAPH_CONTAINER_MARGIN = 16

// The inconsistency icon sits this far left of the paragraph text at the default font size,
export const INCONSISTENCY_INDICATOR_OFFSET = 44
// and at least this far from the list's edge.
export const INCONSISTENCY_INDICATOR_EDGE = 8
// The hover tint reaches this far beyond the paragraph's text on each side (design: 16px across, 10px down).
export const PARAGRAPH_HOVER_INSET_X = 16
export const PARAGRAPH_HOVER_INSET_Y = 10

export const SESSION_NAME_FONT_SIZE_PROPORTION = 1.5
export const SESSION_NAME_LINE_HEIGHT_PROPORTION = 1.5
export const SESSION_NAME_PADDING_TOP = 8
export const SESSION_NAME_PADDING_BOTTOM = 16
export const SESSION_NAME_FONT_WEIGHT = 600
